"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveVariables = exports.axiosInstance = void 0;
const axios_1 = __importDefault(require("axios"));
exports.axiosInstance = axios_1.default.create({
    baseURL: 'https://sagateway.careem-engineering.com/galileo',
});
// map of variable as key and default value as values
function resolveVariables(variablesWithDefaults, tags) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const variablesMap = variablesWithDefaults.map((v) => ({
                variable: v.variable,
            }));
            const { data } = yield exports.axiosInstance.post('/resolve', {
                variables: variablesMap,
                tags,
            });
            if ((data === null || data === void 0 ? void 0 : data.length) > 0)
                return data;
            return variablesWithDefaults;
        }
        catch (error) {
            return variablesWithDefaults;
        }
    });
}
exports.resolveVariables = resolveVariables;
